import http from "@/libs/http";
const base = {
  /**审批后备人才- 系统管理员、青少司 */
  baseApprove: ApproveVO => {
    return http.post(http.formatUrl("base/approve"), ApproveVO);
  },
  /**批量审批后备人才- 系统管理员、青少司 */
  baseApproveBatch: BatchApproveVO => {
    return http.post(http.formatUrl("base/approve/batch"), BatchApproveVO);
  },
  /**删除后备人才 - 系统管理员、省、操作员*/
  baseDelete: TrainingBaseId => {
    return http.post(http.formatUrl("base/delete"), TrainingBaseId);
  },
  /**查看后备人才- 系统管理员、省、操作员*/
  baseInfo: TrainingBaseId => {
    return http.get(http.formatUrl("base/info"), TrainingBaseId);
  },
  /**新建后备人才- 系统管理员、省、操作员*/
  baseInsert: TrainingBaseVO => {
    return http.post(http.formatUrl("base/insert"), TrainingBaseVO);
  },
  /**查询后备人才分页列表 - 系统管理员、省、操作员*/
  basePagelist: BasePageListVO => {
    return http.get(http.formatUrl("base/pagelist"), BasePageListVO);
  },
  /**撤销已提交的后备人才- 系统管理员、项目中心、省*/
  baseRevoke: TrainingBaseId => {
    return http.post(http.formatUrl("base/revoke"), TrainingBaseId);
  },
  /**提交后备人才- 系统管理员、项目中心、省**/
  baseSubmit: TrainingBaseId => {
    return http.post(http.formatUrl("base/submit"), TrainingBaseId);
  },
  /**批量提交后备人才- 系统管理员、项目中心、省**/
  baseSubmitBatch: BatchTrainingBaseId => {
    return http.post(http.formatUrl("base/submit/batch"), BatchTrainingBaseId);
  },
  /**更新后备人才- 系统管理员、省、操作员*/
  baseUpdate: TrainingBaseVO => {
    return http.post(http.formatUrl("base/update"), TrainingBaseVO);
  },
  /**获取基地字典列表*/
  baseDict: TrainingBaseVO => {
    return http.get(http.formatUrl("base/dict"), TrainingBaseVO);
  }
};
export default base;
